var render = function render(){var _vm=this,_c=_vm._self._c;return _c('with-addon-before-info-panel',{staticClass:"has-margin-top",attrs:{"title":"缓缴","data-source":_vm.dataSource,"columns":_vm.contentColumns,"addon-before-columns":_vm.addonBeforeColumns}})
}
var staticRenderFns = []

export { render, staticRenderFns }